import {
  jb_button_secondary_css_default
} from "./chunk.HMLERIWF.js";
import {
  e
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  Linkable
} from "./chunk.534YP5ZJ.js";
import {
  o
} from "./chunk.DJ2G5F2M.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  ButtonElement
} from "./chunk.ALE4QRAM.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-button-secondary/jb-button-secondary.ts
var JbButtonSecondary = class extends Initiable(ButtonElement(Linkable(i))) {
  render() {
    const classes = { inactive: !!this.inactive, hover: !!this.forceHover, inverted: !!this.inverted };
    return this.link?.href ? b`<a
          data-linkable
          part="action"
          class=${e(classes)}
        >
          <slot>${this.text ? o(this.text) : A}</slot>
        </a>` : b`<button
          ?disabled=${this.inactive}
          part="action"
          class=${e(classes)}
        >
          <slot>${this.text ? o(this.text) : A}</slot>
        </button>`;
  }
};
JbButtonSecondary.styles = [reset_css_default, jb_button_secondary_css_default];
JbButtonSecondary.shadowRootOptions = { ...i.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n({ type: Boolean })
], JbButtonSecondary.prototype, "forceHover", 2);
__decorateClass([
  n({ type: Boolean })
], JbButtonSecondary.prototype, "inactive", 2);
__decorateClass([
  n({ type: Boolean })
], JbButtonSecondary.prototype, "inverted", 2);
__decorateClass([
  n({ type: Object })
], JbButtonSecondary.prototype, "link", 2);
__decorateClass([
  n()
], JbButtonSecondary.prototype, "name", 2);
__decorateClass([
  n()
], JbButtonSecondary.prototype, "text", 2);
JbButtonSecondary = __decorateClass([
  customElement("jb-button-secondary")
], JbButtonSecondary);

export {
  JbButtonSecondary
};
